import React, { useContext, memo } from 'react'

import { Row, Tag } from 'antd'

import { DocasContext } from '../Context/context'

const Totais = () => {
  const { docasContext } = useContext(DocasContext)

  const total = () => {
    return (
      (docasContext?.totais?.aprovados || 0) +
      (docasContext?.totais?.bloqueados || 0) +
      (docasContext?.totais?.cancelados || 0) +
      (docasContext?.totais?.livres || 0) +
      (docasContext?.totais?.noShows || 0) +
      (docasContext?.totais?.reservados || 0)
    )
  }

  return (
    <Row>
      <Tag color="#9b9b9b" style={{ color: '#000' }}>
        Livres {docasContext.totais?.livres}
      </Tag>
      <Tag color="#0bc769">Aprovados {docasContext.totais?.aprovados}</Tag>
      <Tag color="#c00808">Bloqueados {docasContext.totais?.bloqueados}</Tag>
      <Tag color="#aca905" style={{ color: '#000' }}>
        Reservados {docasContext.totais?.reservados}
      </Tag>
      <Tag color="#098fb8">Total {total()}</Tag>
    </Row>
  )
}

export default memo(Totais)
